import React from 'react';
import clsx from 'clsx';

const Button = ({
  children,
  onClick,
  type = 'button',
  variant = 'primary',
  size = 'medium',
  disabled = false,
  className = '',
  ...props
}) => {
  // Base styles that apply to all buttons
  const baseStyles = clsx(
    'inline-flex items-center justify-center font-medium rounded-md',
    'transition-colors duration-200 focus:outline-none',
    'focus:ring-2 focus:ring-offset-2 focus:ring-opacity-75',
    disabled && 'opacity-60 cursor-not-allowed'
  );

  // Variant styles
  const variantStyles = {
    primary: 'bg-pinkAccent text-white hover:bg-pink-700 focus:ring-pinkAccent shadow-sm',
    outline: 'border border-gray-300 text-gray-700 hover:bg-gray-50 focus:ring-pinkAccent shadow-sm',
    ghost: 'text-pinkAccent hover:bg-pink-50 focus:ring-pinkAccent',
    danger: 'bg-red-500 text-white hover:bg-red-600 focus:ring-red-500 shadow-sm',
    secondary: 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 shadow-sm',
    cart: 'bg-green-500 text-white hover:bg-green-600 focus:ring-green-500 shadow-sm'
  };

  // Size styles
  const sizeStyles = {
    small: 'px-3 py-1.5 text-xs',
    medium: 'px-4 py-2 text-sm',
    large: 'px-6 py-3 text-base'
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        baseStyles,
        variantStyles[variant],
        sizeStyles[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;